export default function UserModel(nom, prenom, email, role, agences) {
  this.nom = nom;
  this.prenom = prenom;
  this.email = email;
  this.role = role;
  this.agences = agences;
}
